module.exports = __webpack_public_path__ + "img/TRINITYBoardLanding.c789039b.png";